/**
 * Kangavena Tenet - Frontend Timezone & Date Formatting Helper
 * Automatically detects client country IP timezone and formats timestamps correctly.
 */

export function getUserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Colombo';
  } catch {
    return 'Asia/Colombo';
  }
}

export function formatTime(
  date?: Date | string | number | null,
  options?: Intl.DateTimeFormatOptions,
  timeZone?: string
): string {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';

  const tz = timeZone || getUserTimeZone();
  try {
    return d.toLocaleTimeString([], {
      timeZone: tz,
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      ...options,
    });
  } catch {
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true, ...options });
  }
}

export function formatDate(
  date?: Date | string | number | null,
  options?: Intl.DateTimeFormatOptions,
  timeZone?: string
): string {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';

  const tz = timeZone || getUserTimeZone();
  try {
    return d.toLocaleDateString([], {
      timeZone: tz,
      ...options,
    });
  } catch {
    return d.toLocaleDateString([], options);
  }
}

export function formatDateTime(
  date?: Date | string | number | null,
  options?: Intl.DateTimeFormatOptions,
  timeZone?: string
): string {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';

  const tz = timeZone || getUserTimeZone();
  try {
    return d.toLocaleString([], {
      timeZone: tz,
      ...options,
    });
  } catch {
    return d.toLocaleString([], options);
  }
}
